
import { defineComponent } from "vue";
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ToolTip from "@/components/common/ToolTip.vue";
import messages from "@/config/messages";
import common from "@/config/common";
import routesPath from "@/config/routesPath";
import * as apiClient from "@/apiclient/";

export default defineComponent({
  name: "EditEmailView",
  components: {
    ToolTip,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      user: {
        emailAddress: "",
      },
      verificationTxt: "",
      isFormInvalid: false,
      validationMsg: "",
      isSubmitDisabled: false,
      messages,
    };
  },
  validations() {
    return {
      user: {
        emailAddress: { required, email },
      },
    };
  },
  mounted() {
    this.verificationTxt =
      this.$route.query.action === "register" ? "For Verification" : "";
  },
  computed: {
    loginData() {
      const storedData = sessionStorage.getItem(
        common.storageVariables.loginData
      );
      return storedData ? JSON.parse(storedData) : null;
    },
  },
  methods: {
    hideErrors(field: string): void {
      this.v$.user[field].$touch();
      this.isFormInvalid = false;
    },
    buttonDesign(): string {
      const buttonStatus = this.v$.user.emailAddress.$invalid;
      return buttonStatus == true ? "btn-secondary" : "btn-primary";
    },
    async verifyEmail(): Promise<void> {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      this.isSubmitDisabled = true;
      const params = {
        registrationCode: this.loginData.registrationCode,
        ssn: this.loginData.ssn,
        emailAddress: this.user.emailAddress,
      };
      const result = await apiClient
        .loginController()
        .postApiLoginEmailVerification(params);

      this.isSubmitDisabled = false;
      if (!result || result.error) {
        this.isFormInvalid = true;
        if (result.error) {
          this.validationMsg = result.error + messages.errorMsg;
        }
        return;
      } else if (result.data) {
        const loginData = {
          registrationCode: params.registrationCode,
          ssn: params.ssn,
          email: this.user.emailAddress,
          firstLogin:
            this.loginData.firstLogin ??
            this.$route.query.action === "register",
          lastDateToEnroll: result.data.lastDateToEnroll,
          remainingDaysToEnroll: result.data.remainingDaysToEnroll,
        };
        sessionStorage.setItem(
          common.storageVariables.loginData,
          JSON.stringify(loginData)
        );
        sessionStorage.setItem(
          common.storageVariables.otpTimer,
          common.otpTimer
        );
        this.isFormInvalid = false;
        this.$router.push({
          name: routesPath.otpVerification,
        });
      }
    },
  },
});
